import { useEffect } from "react"

const DocRedirect = () => {
    useEffect(() => {
        window.location.replace('https://docs.golendica.com/')
    }, [])
    return <></>
}

export default DocRedirect;